import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '../utils';
import CheckboxFocused from '../assets/images/checkbox-focused.svg';
import CheckboxNotSelected from '../assets/images/checkbox-not-selected.svg';
import CheckboxSelected from '../assets/images/checkbox-selected.svg';

function getBackgroundImage(props) {
  return props.checked ? CheckboxSelected : CheckboxNotSelected;
}

function getBackgroundImageFocused(props) {
  return props.checked ? CheckboxSelected : CheckboxFocused;
}

const CheckboxContainer = styled.div`
  align-self: flex-start;
  background-color: ${props => (props.theme === 'contained' ? colors.g01 : 'transparent')};
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  margin: ${props => (props.theme === 'contained' ? '40' : '13')}px 0;
  padding: ${props => (props.theme === 'contained' ? '14px 16px' : 0)};
  width: ${props => (props.theme === 'contained' ? '100%' : 'auto')};
`;

CheckboxContainer.defaultProps = {
  theme: 'default'
};

const Label = styled.p`
  color: ${colors.g05};
  font-size: ${props => props.fontSize}px;
  font-weight: normal;
  justify-content: left;
  line-height: 1;
  margin: 0 12px;
  width: auto;
`;

Label.defaultProps = {
  fontSize: 16
};

const CheckComponent = styled.input`
  display: none;
`;

const CheckDivComponent = styled.div`
  align-items: center;
  display: flex;
  height: 12px;
  justify-content: center;
  position: relative;
  transition: all 150ms;
  width: 12px;

  &:after {
    align-items: center;
    background-color: white;
    background-image: url(${getBackgroundImage});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100%;
    content: '';
    display: flex;
    height: 12px;
    justify-content: center;
    width: 12px;
  }

  &:focused,
  &:hover {
    &:after {
      background-image: src(${getBackgroundImageFocused});
    }
  }
`;

const Checkbox = props => {
  const { label, checked, onChange, onToggle, theme, style } = props;

  return (
    <CheckboxContainer theme={theme} style={style} onClick={() => onToggle(!checked)}>
      <CheckDivComponent {...props} data-aat={`${props['data-aat']}-div`} checked={checked}>
        <CheckComponent type="checkbox" checked={checked} onChange={onChange} />
      </CheckDivComponent>

      <Label onClick={() => onToggle(!checked)} dangerouslySetInnerHTML={{ __html: label }} />
    </CheckboxContainer>
  );
};

Checkbox.defaultProps = {
  checked: false,
  'data-aat': '',
  onChange: () => {},
  onToggle: () => {},
  label: '',
  theme: 'default',
  style: null
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  'data-aat': PropTypes.string,
  onChange: PropTypes.func,
  onToggle: PropTypes.func,
  label: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  theme: PropTypes.oneOf(['contained', 'default'])
};

export { Checkbox };
